import { v4 as uuidv4 } from 'uuid';

// Local storage keys
const CLIENT_ID_STORAGE_KEY = 'csv_query_client_id';
const SESSION_CREATED_KEY = 'csv_query_session_created';

/**
 * Get the client ID from local storage or generate a new one
 */
export const getClientId = (): string => {
  // Try to get an existing client ID from local storage
  let clientId = localStorage.getItem(CLIENT_ID_STORAGE_KEY);
  
  // If no client ID exists, generate a new one and store it
  if (!clientId) {
    clientId = uuidv4();
    localStorage.setItem(CLIENT_ID_STORAGE_KEY, clientId);
    
    // Store the creation date/time
    const now = new Date().toISOString();
    localStorage.setItem(SESSION_CREATED_KEY, now);
    
    console.log('Generated new client ID:', clientId);
  }
  
  return clientId;
};

/**
 * Get the session creation date/time
 */
export const getSessionCreationDate = (): string => {
  // Try to get the existing creation date
  let creationDate = localStorage.getItem(SESSION_CREATED_KEY);
  
  // If no creation date exists, set it now
  if (!creationDate) {
    creationDate = new Date().toISOString();
    localStorage.setItem(SESSION_CREATED_KEY, creationDate);
  }
  
  return creationDate;
};

/**
 * Add the client ID header to an axios request config
 */
export const addClientIdToRequestConfig = (config: any): any => {
  // Create a new config object to avoid modifying the original
  const newConfig = { ...config };
  
  // Add headers object if it doesn't exist
  if (!newConfig.headers) {
    newConfig.headers = {};
  }
  
  // Add the client ID header
  newConfig.headers['X-Client-ID'] = getClientId();
  
  return newConfig;
};

/**
 * Reset the client ID (useful for testing)
 */
export const resetClientId = (): void => {
  localStorage.removeItem(CLIENT_ID_STORAGE_KEY);
  localStorage.removeItem(SESSION_CREATED_KEY);
};

// Initialize client ID on module load
getClientId();
